import React, { PropTypes, Component } from 'react';
import { Styles, Paper, IconButton } from 'material-ui';
import { StoreOverviewStore } from 'stores';
import { StoreOverviewActions } from 'actions';
import * as Icons from 'components/Material/SvgIcons';
import * as Colors from 'components/Material/Styles/Colors';
import MediaQuery from 'services/MediaQuery';
import { mixin, RefluxMixin } from 'Util';

const { Spacing } = Styles;

const phoneWidth = 5;
const width = 12;

const styles = {
  root: {
    margin: 'auto',
    padding: 0,
    height: 36,
    whiteSpace: 'nowrap',
    position: 'relative',
    backgroundColor: 'transparent'
  },
  inputContainer: {
    display: 'inline-block',
    left: 36,
    right: 0,
    top: 0,
    bottom: 0
  },
  input: {
    border: 'none',
    outline: 'none',
    background: 'transparent',
    width: '100%',
    padding: `0 ${Spacing.desktopGutterMini}px`,
    verticalAlign: 'top',
    lineHeight: `${36}px`,
    height: 36,
    textAlign: 'left',
    boxSizing: 'border-box'
  },
  button: {
    verticalAlign: 'top',
    display: 'inline-block',
    margin: 0,
    border: 'none',
    height: 36,
    left: 0,
    top: 0,
    padding: (36 - Spacing.iconSize) / 2,
    lineHeight: `${36}px`,
    backgroundColor: '#00A1A3'
  },
  activateCode: {
    fontSize: 14,
    position: 'relative',
    top: -8,
    left: -6,
    display: 'inline-block',
    paddingLeft: 14,
    fontWeight: 'bold'
  },
  navigationCheck: {
    marginRight: 4
  }
};

const ESC = 27;
const ENTER = 13;

export default class DiscountField extends mixin(RefluxMixin, Component) {
  static propTypes = {
    onChange: PropTypes.func
  };

  static contextTypes = {
    media: PropTypes.string,
    getIntlMessage: PropTypes.func
  };

  static defaultProps = {
    fullWidth: false
  };

  state = {
    mode: 'edit',
    discountCode: ''
  };

  editMode = () => {
    if (this.state.mode !== 'edit') {
      this.setState({ mode: 'edit' });
      this._timer = setTimeout(() => {
        this.refs.input.focus();
        this.refs.input.select();
        this._timer = null;
      }, 250);
    }
  };

  listenToStores() {
    this.listenToStoreWithMapper(StoreOverviewStore, state => {
      return {
        discountCode: state.discountCode
      };
    });
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    if (this._timer) {
      clearTimeout(this._timer);
    }
  }

  setCode = () => {
    const { onChange } = this.props;
    const discountCode = this.refs.input.value.trim();
    if (discountCode.length === 0) {
      return;
    }
    this.setState({ mode: 'display' });
    StoreOverviewActions.setDiscountCode(discountCode);
    onChange && onChange(discountCode);
  };

  getStyle() {
    const style = Object.assign({}, styles.root);
    if (this.props.fullWidth) {
      style.display = 'block';
    } else {
      style.display = 'inline-block';
      if (this.context.media === 'phone') {
        style.width = Spacing.desktopKeylineIncrement * phoneWidth;
      } else {
        style.width = Spacing.desktopKeylineIncrement * width;
      }
    }
    return style;
  }

  getInputStyle(edit) {
    return Object.assign({}, styles.input, {
      color: edit ? Colors.Colors.fullBlack : Colors.Colors.fullWhite,
      cursor: 'pointer'
    });
  }

  getInputContainerStyle(display) {
    return Object.assign({}, styles.inputContainer, {
      backgroundColor: display
        ? 'rgba(0, 0, 0, 0.2)'
        : 'rgba(255, 255, 255, 0.9)',
      right: display ? 0 : 36,
      width: MediaQuery.phone()
        ? display ? '90%' : '50%'
        : display ? '92%' : '62%'
    });
  }

  getButtonStyle() {
    return Object.assign({}, styles.button, {
      width: MediaQuery.phone() ? '10%' : '8%'
    });
  }

  getCheckButtonStyle = isEmptyDiscountCode => {
    return Object.assign({}, styles.button, {
      width: MediaQuery.phone() ? '40%' : '30%',
      backgroundColor: isEmptyDiscountCode ? '#3c9798' : '#00a1a3',
      color: isEmptyDiscountCode
        ? Colors.Colors.lightWhite
        : Colors.Colors.fullWhite
    });
  };

  handleKey = event => {
    const discountCode = this.refs.input.value.trim();
    this.setState({ discountCode });
    const { keyCode } = event;
    if (keyCode === ESC) {
      this.setState({ mode: 'display' });
    } else if (keyCode == ENTER) {
      this.setCode();
    }
  };

  render() {
    const { mode, discountCode } = this.state;
    const display = mode === 'display';
    const isEmptyDiscountCode =
      !discountCode || discountCode.trim().length === 0;
    let code;
    if (display) {
      const displayCode =
        (discountCode &&
          this.context.getIntlMessage('discount.code') +
            ' : ' +
            discountCode) ||
        this.context.getIntlMessage('discount.code');
      code = (
        <div onTouchTap={this.editMode} style={this.getInputStyle(false)}>
          {displayCode}
        </div>
      );
    } else {
      code = (
        <input
          onKeyUp={this.handleKey}
          defaultValue={discountCode}
          ref="input"
          style={this.getInputStyle(true)}
          type="text"
          placeholder={this.context.getIntlMessage('discount.code')}
        />
      );
    }
    return (
      <Paper style={this.getStyle()}>
        <IconButton style={this.getButtonStyle()} onTouchTap={this.editMode}>
          <Icons.ActionCardGiftcard
            color={Colors.Colors.fullWhite}
            hoverColor={Colors.Colors.lightWhite}
          />
        </IconButton>
        <div style={this.getInputContainerStyle(display)}>{code}</div>
        {mode === 'edit' && (
          <IconButton
            style={this.getCheckButtonStyle(isEmptyDiscountCode)}
            onTouchTap={this.setCode}
          >
            <Icons.NavigationCheck
              style={styles.navigationCheck}
              color={
                isEmptyDiscountCode
                  ? Colors.Colors.lightWhite
                  : Colors.Colors.fullWhite
              }
            />
            <div style={styles.activateCode}>
              <span>{this.context.getIntlMessage('discount.activate')}</span>
            </div>
          </IconButton>
        )}
      </Paper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/DiscountField.js